import React, {Component} from 'react';
import ReactDOM from 'react-dom'
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import isEmpty from 'lodash/isEmpty';

import { PaymentForm } from './'

class ChangePayment extends Component {
  componentDidMount(){
    const element = ReactDOM.findDOMNode(this);
      if (element != null) {
        window.scrollTo(0, this.scrollPosition)
      }
    this.redirectToNewCardUrl()
  }
  // the profile arrives after mount, so the url is usually only known on a later update
  componentDidUpdate(){
    this.redirectToNewCardUrl()
  }
  redirectToNewCardUrl(){
    const { user } = this.props
    if (user && user.newCardUrl) {
      // replace, so going back from the gateway lands on the profile instead of bouncing through here again
      window.location.replace(user.newCardUrl)
    }
  }
  render(){
    const { translate, user } = this.props
    if (isEmpty(user) || user.newCardUrl) {
      return (
        <div></div>
      )
    }
    return(
      <div id="personal-information-edit-payment" >
        <div className="card card-section" id="payment">
          <div className="card-block">
            <div className="card-title">
              <h3>{translate('bank-details')}</h3>
            </div>
            <PaymentForm />
          </div>
        </div>
      </div>
    )
  }
}

const HandlerViewMapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    user: state.User.user,
  }
}

const HandlerViewMapDispatchToProps = (dispatch) => {
  return {
  };
};
  ChangePayment = connect(
    HandlerViewMapStateToProps,
    HandlerViewMapDispatchToProps,
  )(ChangePayment);
export default ChangePayment;



// WEBPACK FOOTER //
// ./src/components/Payment/ChangePayment.js